<ea-button
	[isDisabled]="buttonDisabled"
	class="start-application-btn"
	(click)="handleNewApplicationButtonClick()"
	name="newApplication"
	ariaLabel="{{ ariaLabel }}"
>
	{{ buttonText }}
</ea-button>
